import { Component } from '@angular/core';

@Component({
  selector: 'app-system-admin-panel',
  templateUrl: './system-admin-panel.component.html',
  styleUrls: ['./system-admin-panel.component.scss']
})
export class SystemAdminPanelComponent {

}
